<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Nowa oferta</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/allegro/accounts/list">
            Allegro - Moje konta
          </router-link>
        </li>
        <li>
          <router-link :to="`/allegro/accounts/${accountPk}/overview`">
            {{ accountName }}
          </router-link>
        </li>
        <li>
          <router-link :to="`/allegro/accounts/${accountPk}/offers`">
            Oferty
          </router-link>
        </li>
        <li class="active">
          <strong>Nowa oferta</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Dane oferty</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-12 m-b-xs">
                  <div class="form-group">
                    <label class="control-label col-sm-2">Produkt *</label>
                    <div class="col-sm-10">
                      <Multiselect
                        ref="productSelect"
                        v-model="offerObj.product"
                        mode="single"
                        placeholder="Produkt"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :filter-results="false"
                        :loading="productLoading"
                        :options="products"
                        @search-change="onProductSearch"
                        @open="bindProductScroll"
                        @close="unbindProductScroll"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.product"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.product[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="quantities.length" class="form-group">
                    <label class="control-label col-sm-2">Nakład *</label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.quantity"
                        mode="single"
                        placeholder="Nakład"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="quantities"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.quantity"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.quantity[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="group in visibleGroupOptions"
                    class="form-group"
                    :key="group.group_option.pk"
                  >
                    <label class="control-label col-sm-2">
                      {{ group.group_option.name }}
                      <span>*</span>
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="selectedProductOptions[group.group_option.pk]"
                        :mode="
                          group.group_option.is_multiple ? 'tags' : 'single'
                        "
                        :placeholder="group.group_option.name"
                        track-by="pk"
                        label="label"
                        :close-on-select="!group.group_option.is_multiple"
                        :searchable="true"
                        :options="group.options"
                      >
                      </Multiselect>
                      <div
                        v-if="submitted && getGroupOptionError(group)"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ getGroupOptionError(group) }}
                        </span>
                      </div>
                      <div
                        v-if="errorsAdminData?.data?.chosen_options"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.chosen_options[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="offerObj.product" class="form-group">
                    <label class="control-label col-sm-2">Tytuł *</label>
                    <div class="col-sm-10">
                      <input
                        v-model="offerObj.title"
                        type="text"
                        class="form-control inputClass"
                        placeholder="Tytuł"
                        required="required"
                      />
                      <div
                        v-if="errorsAdminData?.data?.title"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.title[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="offerObj.product" class="form-group">
                    <label class="control-label col-sm-2">Sygnatura *</label>
                    <div class="col-sm-10">
                      <input
                        v-model="offerObj.signature"
                        type="text"
                        maxlength="100"
                        class="form-control inputClass"
                        placeholder="Sygnatura"
                        required="required"
                      />
                      <div
                        v-if="errorsAdminData?.data?.signature"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.signature[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="offerObj.product" class="form-group">
                    <label class="control-label col-sm-2">Opis *</label>
                    <div class="col-sm-10">
                      <Editor
                        api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                        v-model="offerObj.description"
                        :init="{
                          toolbar_mode: 'sliding',
                          plugins:
                            'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                          toolbar:
                            'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                        }"
                      />
                      <div
                        v-if="errorsAdminData?.data?.price"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.price[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="offerObj.product" class="form-group">
                    <label class="control-label col-sm-2">
                      Dostępna ilość kompletów *
                    </label>
                    <div class="col-sm-10">
                      <input
                        v-model="offerObj.available_number"
                        type="number"
                        class="form-control inputClass"
                        placeholder="Dostępna ilość kompletów"
                        required="required"
                      />
                      <div
                        v-if="errorsAdminData?.data?.available_number"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.available_number[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="offerObj.product" class="form-group">
                    <label class="control-label col-sm-2">Cena *</label>
                    <div class="col-sm-10">
                      <input
                        v-model="offerObj.price"
                        type="number"
                        class="form-control inputClass"
                        placeholder="Cena"
                        required="required"
                      />
                      <div
                        v-if="errorsAdminData?.data?.price"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.price[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="offerObj.product" class="form-group">
                    <label class="control-label col-sm-2">Kategoria *</label>
                    <div class="col-sm-10">
                      <span v-if="cat" class="badge badge-primary">
                        <small class="badge badge-light m-r-xs">
                          {{ cat?.id }}
                        </small>
                        <strong>{{ cat?.name }}</strong>
                      </span>
                      <button @click="mActions = true" class="btn btn-link">
                        Wybierz kategorię
                      </button>
                    </div>
                  </div>
                  <div
                    v-for="(param, key) in parameters"
                    class="form-group"
                    :key="key"
                  >
                    <label class="control-label col-sm-2">
                      {{ param.name }}
                      <span v-if="param.required">*</span>
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-if="param.type === 'dictionary'"
                        v-model="param.objectModel[param.id]"
                        :mode="
                          param.restrictions?.multipleChoices
                            ? 'tags'
                            : 'single'
                        "
                        :placeholder="param.name"
                        track-by="name"
                        label="name"
                        :close-on-select="!param.restrictions?.multipleChoices"
                        :searchable="true"
                        :options="param.dictionary"
                        @close="markParameterTouched(param)"
                      >
                      </Multiselect>

                      <input
                        v-if="
                          param.type === 'float' || param.type === 'integer'
                        "
                        v-model="param.objectModel[param.id]"
                        type="number"
                        :step="
                          param.type === 'float'
                            ? param.restrictions?.precision || 'any'
                            : '1'
                        "
                        :min="param.restrictions?.min"
                        :max="param.restrictions?.max"
                        class="form-control inputClass"
                        :placeholder="param.name"
                        :required="param.required"
                        @blur="markParameterTouched(param)"
                      />
                      <input
                        v-if="param.type === 'string'"
                        v-model="param.objectModel[param.id]"
                        type="text"
                        :minlength="param.restrictions?.minLength"
                        :maxlength="param.restrictions?.maxLength"
                        class="form-control inputClass"
                        :placeholder="param.name"
                        :required="param.required"
                        @blur="markParameterTouched(param)"
                      />
                      <small v-if="param.unit" class="field-unit text-muted">
                        Wyrażone w jednostkach:
                        <strong>{{ param.unit }}</strong>
                      </small>
                      <div
                        v-if="
                          isParameterErrorVisible(param) &&
                          getParameterError(param)
                        "
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ getParameterError(param) }}
                        </span>
                      </div>

                      <div v-if="isAmbiguousValueVisible(param)">
                        <label class="control-label m-t-sm">
                          Wartość
                          <span v-if="param.required">*</span>
                        </label>
                        <input
                          v-model="
                            param.objectModel[`ambiguous_value_${param.id}`]
                          "
                          type="text"
                          class="form-control inputClass"
                          placeholder="Wartość"
                          :required="param.required"
                          @blur="markParameterTouched(param)"
                        />
                        <div
                          v-if="
                            isParameterErrorVisible(param) &&
                            getAmbiguousValueError(param)
                          "
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ getAmbiguousValueError(param) }}
                          </span>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </div>
                  <div v-if="cat" class="form-group">
                    <label class="control-label col-sm-2">
                      Cennik dostawy *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.data.shoppingRate"
                        mode="single"
                        placeholder="Cennik dostawy"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="rates"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.returnPolicy"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.returnPolicy[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="cat" class="form-group">
                    <label class="control-label col-sm-2">
                      Warunki reklamacji *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.data.impliedWarranty"
                        mode="single"
                        placeholder="Warunki reklamacji"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="warranties"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.returnPolicy"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.returnPolicy[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="cat" class="form-group">
                    <label class="control-label col-sm-2">
                      Warunki zwrotów *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.data.returnPolicy"
                        mode="single"
                        placeholder="Warunki zwrotów"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="returns"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.returnPolicy"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.returnPolicy[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="cat" class="form-group">
                    <label class="control-label col-sm-2">
                      Czas publikacji *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.publication_duration"
                        mode="single"
                        placeholder="Czas publikacji"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="durations"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.delivery_handling_time"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.delivery_handling_time[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="cat" class="col-sm-offset-2 col-sm-10 mb-25">
                    <div>
                      <label>
                        <input v-model="offerObj.republish" type="checkbox" />
                        <span> Wznów automatycznie publikację</span>
                      </label>
                    </div>
                    <div>
                      <small class="form-text text-muted ng-scope">
                        Oferta wznawiana jest ze stałą początkową liczbą
                        przedmiotów niezależnie od tego, ile przedmiotów
                        sprzedasz.
                      </small>
                    </div>
                  </div>
                  <div v-if="cat" class="form-group">
                    <label class="control-label col-sm-2">
                      Czas wysyłki *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.delivery_handling_time"
                        mode="single"
                        placeholder="Czas wysyłki"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="times"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.delivery_handling_time"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.delivery_handling_time[0] }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="col-sm-4 col-sm-offset-2">
                      <router-link
                        class="btn btn-white"
                        :to="`/allegro/accounts/${accountPk}/offers`"
                      >
                        Anuluj
                      </router-link>
                      <button
                        v-if="canAddOffer"
                        :disabled="isSubmitting"
                        @click="create"
                        class="btn btn-primary"
                      >
                        {{ isSubmitting ? "Zapisywanie..." : "Dodaj" }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="mActions" class="modal-dialog category-select-modal">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Wybór kategorii</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal discounts">
            <div class="row m-b-sm">
              <div v-if="categoriesMatch?.length" class="matched">
                <h3>Proponowane kategorie:</h3>
                <div class="btn-group btn-group-justified">
                  <label
                    v-for="(category, key) in categoriesMatch"
                    :key="key"
                    class="btn btn-xs btn-default cmatch-label"
                    @click="selectMCategory(category)"
                    :class="{ active: cat?.id == category.id }"
                  >
                    {{ category.label_with_parent_name }}
                  </label>
                </div>
                <hr />
              </div>
              <div v-if="categories?.length">
                <h3>Wybór ręczny:</h3>
                <div v-if="selCategory.length" class="selCategories">
                  <span
                    v-for="(crumb, key) in selCategory"
                    class="inlineb"
                    :key="key"
                  >
                    {{ crumb.name }}
                    <span v-if="key < selCategory.length - 1" class="m-l-xs">
                      -
                    </span>
                  </span>

                  <button
                    class="btn btn-primary inlineb category-back-btn"
                    @click="categoryBack"
                  >
                    Cofnij
                  </button>
                </div>
                <ul class="category-list">
                  <li
                    v-for="(category, key) in categories"
                    :key="key"
                    class="category-list__item"
                    @click="selectCategory(category)"
                  >
                    <a
                      class="category-list__item-link"
                      :class="{ selected: cat?.id === category.id }"
                    >
                      {{ category.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mActions = false" class="btn btn-white">
            Anuluj
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mActions" @click="mActions = false" class="modal-backdrop"></div>
</template>

<script>
import { computed, nextTick, onUnmounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import Editor from "@tinymce/tinymce-vue";
import router from "../../router/router";
import {
  allegroOfferMessagesConst,
  allegroOfferPermissionsConst,
} from "../../constants/allegroConstants";
import { hasPermission } from "../../permissions";

// Flattens a DRF error payload down to the first readable message
const getFirstErrorMessage = (data) => {
  const entries = Object.entries(data || {});
  if (!entries.length) {
    return allegroOfferMessagesConst.error;
  }
  const [key, value] = entries[0];
  return `${key}: ${Array.isArray(value) ? value[0] : value}`;
};

export default {
  name: "OffersCreate",
  mixins: [],
  components: {
    Multiselect,
    Editor,
  },
  props: {},

  setup() {
    const store = useStore();
    const route = useRoute();

    const canAddOffer = computed(() =>
      hasPermission(allegroOfferPermissionsConst.add)
    );

    const productOfferPricingData = computed(
      () => store.getters.getProductOfferPricingData
    );
    const productOfferWeightData = computed(
      () => store.getters.getProductOfferWeightData
    );
    const productOfferDescriptionData = computed(
      () => store.getters.getProductOfferDescriptionData
    );
    const adminGPData = computed(() => store.getters.getAdminGPData);
    const adminQuantitiesData = computed(
      () => store.getters.getAdminQuantitiesData
    );
    const allCategoriesData = computed(
      () => store.getters.getAllCategoriesData
    );
    const allMatchCategoriesData = computed(
      () => store.getters.getAllMatchCategoriesData
    );
    const allCatPData = computed(() => store.getters.getAllCatPData);
    const createAllOfferData = computed(
      () => store.getters.getCreateAllOfferData
    );
    const allDeliveryTimesData = computed(
      () => store.getters.getAllDeliveryTimesData
    );
    const allDurationsPubData = computed(
      () => store.getters.getAllDurationsPubData
    );
    const allReturnData = computed(() => store.getters.getAllReturnData);
    const allWarrantiesData = computed(
      () => store.getters.getAllWarrantiesData
    );
    const allShopingRatesData = computed(
      () => store.getters.getAllShopingRatesData
    );
    // The same initial shape the old admin panel starts the offer form with
    const offerObj = ref({
      product: null,
      quantity: null,
      chosen_options: [],
      title: "",
      signature: "",
      description: "",
      available_number: null,
      price: null,
      publication_duration: "WSL",
      republish: false,
      delivery_handling_time: null,
      data: {
        category: null,
        parameters: [],
        shoppingRate: null,
        impliedWarranty: null,
        returnPolicy: null,
      },
    });
    // The offer is always created in the context of a chosen Allegro account -
    // its OAuth configuration is what the dictionaries below are read through.
    const accountPk = Number(route.params.pk);
    offerObj.value.account = accountPk;
    offerObj.value.allegro_account = accountPk;

    const allegroAccountData = computed(
      () => store.getters.getAllegroAccountData
    );
    const accountName = computed(
      () => allegroAccountData.value?.data?.name || "-"
    );

    // A missing account means the form has nothing to create the offer for
    watch(
      () => allegroAccountData.value,
      (newValue) => {
        if (newValue?.status === 404) {
          router.push("/allegro/accounts/list").then(() => {
            store.dispatch("showToaster", {
              type: "error",
              content: newValue.data?.detail || "Nie znaleziono konta Allegro.",
            });
          });
        }
      },
      { deep: true }
    );

    const rates = ref([]);
    const warranties = ref([]);
    const returns = ref([]);
    const durations = ref([]);
    const times = ref([]);
    const products = ref([]);
    // Options already seen, so a product picked earlier stays resolvable even
    // when a later search or page no longer contains it
    const productsByPk = ref({});

    // --- Product picker: server side search + paging while scrolling ---
    // Mirrors data-on-search / cp-infinity-scroll from the old admin panel.
    const productSelect = ref(null);
    const productLoading = ref(false);
    const productPage = ref(1);
    const productQuery = ref("");
    const productHasMore = ref(false);

    const mapProductOption = (element) => {
      const option = {
        name: "[" + element.pk + "] " + element.name,
        baseName: element.name,
        nameMatch: element.category_names?.[0] || element.name.split(" ")[0],
        raw: element,
        value: element.pk,
      };
      productsByPk.value[element.pk] = option;
      return option;
    };

    const fetchProducts = ({ page = 1, name = "", append = false }) => {
      if (productLoading.value) {
        return;
      }
      productLoading.value = true;

      store
        .dispatch("getAllProducts", { page: page, name: name })
        .then((response) => {
          const results = (response.data?.results || []).map(mapProductOption);
          products.value = append ? products.value.concat(results) : results;
          productHasMore.value = Boolean(response.data?.next);
          productPage.value = page;
        })
        .catch(() => {
          productHasMore.value = false;
        })
        .finally(() => {
          productLoading.value = false;
        });
    };

    // The old panel debounces the search by 1000 ms (refresh-delay)
    let productSearchTimeout = null;
    const onProductSearch = (query) => {
      clearTimeout(productSearchTimeout);
      productSearchTimeout = setTimeout(() => {
        productQuery.value = query || "";
        fetchProducts({ page: 1, name: productQuery.value, append: false });
      }, 1000);
    };

    const loadMoreProducts = () => {
      if (!productHasMore.value || productLoading.value) {
        return;
      }
      fetchProducts({
        page: productPage.value + 1,
        name: productQuery.value,
        append: true,
      });
    };

    let productDropdownEl = null;
    const onProductDropdownScroll = (event) => {
      const el = event.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
        loadMoreProducts();
      }
    };

    const unbindProductScroll = () => {
      if (productDropdownEl) {
        productDropdownEl.removeEventListener(
          "scroll",
          onProductDropdownScroll
        );
        productDropdownEl = null;
      }
    };

    const bindProductScroll = () => {
      nextTick(() => {
        unbindProductScroll();
        productDropdownEl = productSelect.value?.$el?.querySelector(
          ".multiselect-dropdown"
        );
        if (productDropdownEl) {
          productDropdownEl.addEventListener("scroll", onProductDropdownScroll);
        }
      });
    };

    onUnmounted(unbindProductScroll);
    // --- End: product picker ---

    const quantities = ref([]);
    const gps = ref([]);
    const selectedProductOptions = ref({});
    const mActions = ref(false);
    const offerWeight = ref(0);
    const categories = ref();
    const categoriesMatch = ref();
    const selCategory = ref([]);
    const parameters = ref([]);
    const errorsAdminData = ref();
    const cat = ref();
    const asList = (data, keys = []) => {
      if (Array.isArray(data)) {
        return data;
      }
      if (Array.isArray(data?.results)) {
        return data.results;
      }
      for (const key of keys) {
        if (Array.isArray(data?.[key])) {
          return data[key];
        }
      }
      return [];
    };
    const selectedProduct = () => productsByPk.value[offerObj.value.product];
    const selectedQuantity = () =>
      quantities.value.find(
        (quantity) => quantity.value === offerObj.value.quantity
      );
    // Options are held per group pk, the way selectedProductOptions works in
    // the old admin panel, and flattened only when the offer is submitted.
    const chosenOptionPks = () =>
      Object.values(selectedProductOptions.value)
        .flat()
        .filter((pk) => pk !== undefined && pk !== null && pk !== "");
    // Each category parameter keeps its value under objectModel[id], the same
    // way the dynamic-fields directive does it in the old admin panel.
    const initialParametersObjModel = (params) => {
      params.forEach((parameter) => {
        parameter.objectModel = {};
        if (
          parameter.type === "dictionary" &&
          parameter.restrictions?.multipleChoices
        ) {
          parameter.objectModel[parameter.id] = [];
        } else {
          parameter.objectModel[parameter.id] = "";
        }

        if (
          offerWeight.value > 0 &&
          parameter.name?.toLowerCase().includes("waga")
        ) {
          parameter.objectModel[parameter.id] = offerWeight.value;
        }
      });
    };

    // --- Category parameter validation ---
    // Messages and rules taken from the dynamic-fields directive of the old
    // admin panel. Required errors show after a submit attempt, the remaining
    // ones once the field has been touched.
    const submitted = ref(false);
    const isSubmitting = ref(false);
    const touchedParameters = ref({});

    const markParameterTouched = (parameter) => {
      touchedParameters.value[parameter.id] = true;
    };

    const isValueEmpty = (value) =>
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);

    const getParameterError = (parameter) => {
      const value = parameter.objectModel?.[parameter.id];
      const restrictions = parameter.restrictions || {};

      if (isValueEmpty(value)) {
        return parameter.required ? "To pole nie może być puste." : null;
      }

      if (parameter.type === "string") {
        const length = String(value).length;
        if (restrictions.minLength && length < restrictions.minLength) {
          return `Minimalna ilość znaków to ${restrictions.minLength}.`;
        }
        if (restrictions.maxLength && length > restrictions.maxLength) {
          return `Maksymalna ilość znaków to ${restrictions.maxLength}.`;
        }
      }

      if (parameter.type === "float" || parameter.type === "integer") {
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) {
          return "Niepoprawna wartość pola liczby całkowitej.";
        }
        if (
          restrictions.min !== undefined &&
          restrictions.min !== null &&
          numberValue < restrictions.min
        ) {
          return `Wartość musi wynosić przynajmniej ${restrictions.min}.`;
        }
        if (
          restrictions.max !== undefined &&
          restrictions.max !== null &&
          numberValue > restrictions.max
        ) {
          return `Wartość musi wynosić co najwyżej ${restrictions.max}.`;
        }
      }

      return null;
    };

    const getAmbiguousValueError = (parameter) => {
      if (!parameter.required) {
        return null;
      }
      const value = parameter.objectModel?.[`ambiguous_value_${parameter.id}`];
      return isValueEmpty(value) ? "To pole nie może być puste." : null;
    };

    const isParameterErrorVisible = (parameter) =>
      submitted.value || touchedParameters.value[parameter.id];

    const getGroupOptionError = (group) => {
      const value = selectedProductOptions.value[group.group_option.pk];
      return isValueEmpty(value) ? "To pole nie może być puste." : null;
    };
    // --- End: category parameter validation ---

    const isAmbiguousValueVisible = (parameter) =>
      parameter.type === "dictionary" &&
      parameter.options?.ambiguousValueId &&
      parameter.objectModel?.[parameter.id] ===
        parameter.options.ambiguousValueId;

    // Groups that let the client type in their own value cannot be expressed
    // in an Allegro offer, so the old admin panel hides them from the wizard.
    const isPossibleDisplayProductGroupOption = (group) => {
      return (group.options || []).some(
        (option) => option.enter_values_possible
      );
    };
    const visibleGroupOptions = computed(() =>
      gps.value.filter((group) => !isPossibleDisplayProductGroupOption(group))
    );
    const isProductGroupOptionFieldsFilled = () => {
      return visibleGroupOptions.value.every((group) => {
        const value = selectedProductOptions.value[group.group_option.pk];
        return Array.isArray(value) ? value.length > 0 : Boolean(value);
      });
    };
    const isBasicFieldsFilled = () => {
      return (
        offerObj.value.product &&
        offerObj.value.quantity &&
        isProductGroupOptionFieldsFilled()
      );
    };
    const updateOfferTitle = () => {
      const product = selectedProduct();
      const quantity = selectedQuantity();

      offerObj.value.title = product?.raw?.name || product?.baseName || "";
      if (quantity) {
        offerObj.value.title += ", " + quantity.display_quantity + " szt.";
      }
    };
    const getOfferDerivedData = (withDescription = false) => {
      if (!offerObj.value.product || !offerObj.value.quantity) {
        return;
      }
      const payload = {
        pk: offerObj.value.product,
        quantity_pk: offerObj.value.quantity,
        option_pk: chosenOptionPks(),
      };
      store.dispatch("getProductOfferPricing", payload);
      store.dispatch("getProductOfferWeight", payload);
      if (withDescription && isBasicFieldsFilled()) {
        store.dispatch("getProductOfferDescription", payload);
      }
    };

    fetchProducts({});
    store.dispatch("getAllegroAccount", accountPk);

    store.dispatch("getAllShopingRates", { accountPk });
    store.dispatch("getAllWarranties", { accountPk });
    store.dispatch("getAllDeliveryTimes", { accountPk });
    store.dispatch("getAllDurationsPub", { accountPk });
    store.dispatch("getAllReturn", { accountPk });

    const selectCategory = (category) => {
      selCategory.value.push({
        id: category.id,
        name: category.name,
      });
      if (category.leaf) {
        cat.value = category;
        offerObj.value.data.category = category.id;
        mActions.value = false;
      }
    };

    const selectMCategory = (category) => {
      cat.value = category;
      offerObj.value.data.category = category.id;
      mActions.value = false;
    };

    const categoryBack = () => {
      selCategory.value.pop();
    };

    const create = () => {
      if (!canAddOffer.value) {
        return;
      }
      if (isSubmitting.value) {
        return;
      }
      submitted.value = true;

      // The old panel guards the submit with form.$valid
      const hasInvalidGroupOption = visibleGroupOptions.value.some((group) =>
        getGroupOptionError(group)
      );
      const hasInvalidParameter = parameters.value.some(
        (parameter) =>
          getParameterError(parameter) ||
          (isAmbiguousValueVisible(parameter) &&
            getAmbiguousValueError(parameter))
      );

      if (hasInvalidGroupOption || hasInvalidParameter) {
        store.dispatch("showToaster", {
          type: "error",
          content: "Uzupełnij wymagane pola formularza.",
        });
        return;
      }

      isSubmitting.value = true;
      offerObj.value.chosen_options = chosenOptionPks();
      store.dispatch("createAllOffer", offerObj.value);
    };

    watch(
      () => allDeliveryTimesData.value,
      function (newValue) {
        times.value = [];
        asList(newValue?.data, ["deliveryHandlingTimes"]).forEach((element) => {
          times.value.push({
            name: element.name,
            value: element.id,
          });
        });
      }
    );

    watch(
      () => allDurationsPubData.value,
      function (newValue) {
        durations.value = [];
        asList(newValue?.data, ["publicationDurations"]).forEach((element) => {
          durations.value.push({
            name: element.name,
            value: element.id,
          });
        });
      }
    );

    watch(
      () => allReturnData.value,
      function (newValue) {
        returns.value = asList(newValue?.data, ["returnPolicies"]).map(
          (element) => ({
            name: element.name,
            value: element.id,
          })
        );
      }
    );

    watch(
      () => allShopingRatesData.value,
      function (newValue) {
        rates.value = asList(newValue?.data, ["shippingRates"]).map(
          (element) => ({
            name: element.name,
            value: element.id,
          })
        );
      }
    );
    watch(
      () => allWarrantiesData.value,
      function (newValue) {
        warranties.value = asList(newValue?.data, ["impliedWarranties"]).map(
          (element) => ({
            name: element.name,
            value: element.id,
          })
        );
      }
    );

    watch(
      () => offerObj.value?.product,
      function (newValue) {
        if (!newValue) {
          return;
        }
        offerObj.value.quantity = null;
        offerObj.value.chosen_options = [];
        selectedProductOptions.value = {};
        offerObj.value.data.category = null;
        offerObj.value.data.parameters = [];
        parameters.value = [];
        cat.value = null;
        selCategory.value = [];
        store.dispatch("getAdminQuantities", newValue);
        store.dispatch("getAdminGP", newValue);
        store.dispatch("getAllCategories", { accountPk });
        if (productsByPk.value[newValue]?.nameMatch) {
          store.dispatch("getAllMatchCategories", {
            accountPk,
            categoryName: productsByPk.value[newValue].nameMatch,
          });
        }
        updateOfferTitle();
      }
    );

    watch(
      () => offerObj.value?.quantity,
      function (newValue) {
        if (!newValue) {
          return;
        }
        updateOfferTitle();
        getOfferDerivedData(false);
      }
    );

    watch(
      () => selectedProductOptions.value,
      function () {
        if (isBasicFieldsFilled()) {
          getOfferDerivedData(true);
        }
      },
      { deep: true }
    );

    watch(
      () => adminQuantitiesData.value,
      function (newValue) {
        quantities.value = [];
        newValue.data?.forEach((element) => {
          quantities.value.push({
            name: "[" + element.pk + "] " + element.display_quantity,
            value: element.pk,
            display_quantity: element.display_quantity,
          });
        });
      }
    );

    watch(
      () => adminGPData.value,
      function (newValue) {
        let options = [];
        gps.value = [];
        newValue.data?.forEach((element) => {
          options = [];
          element.options.forEach((option) => {
            option.value = option.pk;
            options.push(option);
          });
          element.options = options;
          gps.value.push(element);
        });
      }
    );

    watch(
      () => allCategoriesData.value,
      function (newValue) {
        if (newValue.data?.categories) {
          categories.value = newValue.data.categories;
        }
      }
    );

    watch(
      () => allMatchCategoriesData.value,
      function (newValue) {
        if (newValue.data?.matchingCategories) {
          categoriesMatch.value = newValue.data.matchingCategories;
        }
      }
    );

    watch(
      () => cat.value,
      function (newValue) {
        if (!newValue?.id) {
          return;
        }
        store.dispatch("getAllCategoryParameters", {
          accountPk,
          categoryId: newValue.id,
        });
      }
    );

    watch(
      () => allCatPData.value,
      function (newValue) {
        const params = newValue.data?.parameters || [];
        params.forEach((element) => {
          element.dictionary = (element.dictionary || []).map((elem) => ({
            name: elem.value,
            value: elem.id,
          }));
        });
        initialParametersObjModel(params);
        // Rebuilt from scratch - a category change replaces the whole set
        offerObj.value.data.parameters = params;
        parameters.value = params;
      }
    );

    watch(
      () => productOfferPricingData.value,
      function (newValue) {
        if (newValue?.status === 200 && newValue.data?.price !== undefined) {
          offerObj.value.price = newValue.data.price;
        }
      }
    );

    watch(
      () => productOfferDescriptionData.value,
      function (newValue) {
        if (
          newValue?.status === 200 &&
          newValue.data?.description !== undefined
        ) {
          offerObj.value.description = newValue.data.description;
        }
      }
    );

    watch(
      () => productOfferWeightData.value,
      function (newValue) {
        if (newValue?.status !== 200 || !newValue.data?.weight) {
          return;
        }
        // Kept for parameters loaded later, after the category is picked
        offerWeight.value = newValue.data.weight;

        const weightParameter = offerObj.value.data.parameters?.find(
          (parameter) => parameter.name?.toLowerCase().includes("waga")
        );
        if (weightParameter) {
          weightParameter.objectModel = weightParameter.objectModel || {};
          weightParameter.objectModel[weightParameter.id] =
            newValue.data.weight;
        }
      }
    );

    watch(
      () => selCategory.value,
      function () {
        // An empty path means the root level - without this "Cofnij" left the
        // list showing the previous level
        const parent = selCategory.value[selCategory.value.length - 1];
        store.dispatch("getAllCategories", {
          accountPk,
          parentId: parent?.id,
        });
      },
      { deep: true }
    );

    watch(
      () => createAllOfferData.value,
      function (newValue) {
        isSubmitting.value = false;

        if (newValue.status >= 200 && newValue.status < 300) {
          const externalErrors = newValue.data?.external_errors || {};

          // Toasts are raised once the navigation settled - showing them
          // first makes the redirect cut them off after a blink.
          if (Object.keys(externalErrors).length === 0) {
            router.push(`/allegro/accounts/${accountPk}/offers`).then(() => {
              store.dispatch("showToaster", {
                type: "success",
                content: allegroOfferMessagesConst.add,
              });
            });
            return;
          }

          // The offer got created but Allegro rejected it - the old panel
          // shows the errors and moves on to its edit form.
          router.push(`/allegro/offers/update/${newValue.data.pk}`).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: allegroOfferMessagesConst.add,
            });
            store.dispatch("showToaster", {
              type: "error",
              content: getFirstErrorMessage(externalErrors),
            });
          });
          return;
        }

        store.dispatch("showToaster", {
          type: "error",
          content: getFirstErrorMessage(newValue.data),
        });
        errorsAdminData.value = newValue;
      }
    );

    return {
      canAddOffer,
      offerObj,
      products,
      productSelect,
      productLoading,
      onProductSearch,
      bindProductScroll,
      unbindProductScroll,
      quantities,
      gps,
      visibleGroupOptions,
      selectedProductOptions,
      mActions,
      isAmbiguousValueVisible,
      submitted,
      isSubmitting,
      markParameterTouched,
      isParameterErrorVisible,
      getParameterError,
      getAmbiguousValueError,
      getGroupOptionError,
      categories,
      categoriesMatch,
      selCategory,
      selectCategory,
      selectMCategory,
      categoryBack,
      parameters,
      create,
      errorsAdminData,
      cat,
      times,
      durations,
      returns,
      warranties,
      rates,
      accountPk,
      accountName,
    };
  },
  computed: {},
};
</script>

<style scoped>
/* Bootstrap 5 has no .btn-xs - the category breadcrumb button is kept small
   without pulling that class back in globally */
.category-back-btn {
  border-radius: 3px;
  font-size: 12px;
  line-height: 1.5;
  padding: 1px 5px;
}
</style>
